import { toPersianDateTime } from 'utils/gmt-to-local-persian-date'
import { StarRating } from './StarRating'
import { faUser } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

interface Review {
  id: number
  customerFirstName: string
  customerLastName: string
  customerId: string
  rating: number
  comment: string
  createdAt: string
}

export const ReviewCard = ({ review }: { review: Review }) => (
  <div className='flex space-x-4 space-x-reverse py-4 border-b last:border-b-0' style={{ borderColor: 'var(--border-color)' }}>
    <FontAwesomeIcon
      icon={faUser}
      style={{
        fontSize: 50,

        margin: 10,
      }}
      className='w-14 h-14 rounded-full object-cover'
    />
    <div className='flex-1'>
      <div className='flex items-center justify-between'>
        <div>
          <p className='font-semibold' style={{ color: 'var(--text-primary)' }}>{`${review.customerFirstName} ${review.customerLastName}`}</p>
          <p className='text-xs' style={{ color: 'var(--text-tertiary)' }}>
            {toPersianDateTime(review.createdAt)}
          </p>{' '}
        </div>
        <StarRating rating={review.rating} size={5} />
      </div>
      <p className='mt-2' style={{ color: 'var(--text-secondary)' }}>{review.comment}</p>
    </div>
  </div>
)
